import styled from '@emotion/styled';

import { customPalette } from '../../styles/theme';

export const RedCertSection = styled.section`
  padding: 24px 0;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  color: ${customPalette.grey.main};
  margin-bottom: 24px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${customPalette.grey[0]};
  border-radius: 8px;
  width: 100%;
`;
